import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop: React.FC = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Hash - scroll to corresponding element
      const element = document.querySelector(hash);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    } else {
      // Scroll to top of the page
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [pathname, hash]); // Run the effect whenever the pathname or hash changes

  return null;
};
